import React from 'react'

function ConversationSearch() {
    return (
        <div className="collapse border-bottom px-3" id="searchCollapse">
        <div className="container-xl py-2 px-0 px-md-3">
          <div className="input-group bg-light ">
            <input
              type="text"
              className="form-control form-control-md border-right-0 transparent-bg pr-0"
              placeholder="Search..."
            />
            <div className="input-group-append">
              <span className="input-group-text transparent-bg border-left-0">
                <svg
                  className="hw-20 text-muted"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ConversationSearch
